<template>
  <v-card class="class-report" flat>
    <div class="band">
      <v-btn
        fab
        small
        color="white"
        outlined
        class="close-button"
        @click="$emit('close-tab')"
      >
        <v-icon dark>close</v-icon>
      </v-btn>
    </div>
    <v-row class="ma-3">
      <v-col cols="12">
        <h2 class="headline">Class Report</h2>
        <p>Below choose which {{ lessonTerm }} you would like to report on</p>
        <v-select
          :items="lessons"
          item-text="name"
          item-value="id"
          v-model="lessonId"
          :label="`Choose ${capitalizeFirstLetter(lessonTerm)}`"
        ></v-select>
      </v-col>
      <transition name="slide-y-transition" mode="out-in">
        <v-col cols="12" v-show="lessonId">
          <class-lesson-completion
            :lesson="lesson"
            :custom-class="customClass"
          />
          <class-quiz-report
            v-show="lesson && userLessons"
            ref="preQuizClassReport"
            title="Pre Quiz"
            type="pre_quiz"
            :lesson="lesson"
            :user-lessons="userLessons"
          />
          <class-quiz-report
            v-show="lesson && userLessons"
            ref="postQuizClassReport"
            title="Post Quiz"
            type="post_quiz"
            :lesson="lesson"
            :user-lessons="userLessons"
          />
        </v-col>
      </transition>
    </v-row>
  </v-card>
</template>

<script>
import Lesson from '@/modules/lesson/models/Lesson'
// import UserLesson from '@/modules/lesson/models/UserLesson'
import ClassQuizReport from './ClassQuizReport'
import ClassLessonCompletion from './ClassLessonCompletion'
import { mapState } from 'vuex'

export default {
  name: 'ClassReport',
  components: {
    ClassQuizReport,
    ClassLessonCompletion
  },
  props: {
    customClass: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      active: 0,
      lessonId: null,
      userLessons: [],
      lesson: null
    }
  },
  async mounted() {
    this.userLessons = await this.$axios.get(
      `api/teachers/reports?&current_class_id=${this.customClass.id}&type=completedStudentLessonByClass&date_start=2019-01-01&date_end=2019-01-01`
    )
  },
  watch: {
    lessonId(val) {
      this.lesson = Lesson.find(val)
      this.$nextTick(() => {
        this.$refs.preQuizClassReport.updateCharts()
        this.$refs.postQuizClassReport.updateCharts()
      })
    }
  },
  computed: {
    ...mapState(['lessonTerm']),
    lessons() {
      return Lesson.all()
    }
  },
  methods: {}
}
</script>

<style lang="scss">
.class-report {
}
</style>
